import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import lang from '@/lang'

import FileExplorerDialog from '@/modules/file/components/file-explorer-dialog'

import { toast } from '@/modules/base/components/toast/toastConfig'
import { FILE_LIST_FILTER } from '@/modules/base/util/constants'

const DashboardTodoFileListComponent = props => {
  const {
    onClose: onCloseHandler,
    onSelect: onSelectHandler,
    onPreview: onPreviewHandler,
    filter,
    tenantCollaborationId,
  } = props

  const { error } = useSelector(state => state.document.list)

  useEffect(() => {
    if (error) {
      const message = lang.defaultErrorMessage
      toast.showToast({ type: 'error', message })
    }
  }, [error])

  const onSelectFile = file => {
    if (onSelectHandler) {
      onSelectHandler(file)
    }
  }

  const onClose = () => {
    if (onCloseHandler) {
      onCloseHandler()
    }
  }

  const handlePreview = (file, previewControlHandlers) => {
    if (onPreviewHandler) {
      onPreviewHandler(file, previewControlHandlers)
    }
  }

  return (
    <FileExplorerDialog
      tenantCollaborationId={tenantCollaborationId}
      onClose={onClose}
      onSelectFile={onSelectFile}
      previewDialog={handlePreview}
      displayClose={false}
      filter={filter || FILE_LIST_FILTER.NO_INVOICES}
    />
  )
}

DashboardTodoFileListComponent.propTypes = {
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  onPreview: PropTypes.func,
  tenantCollaborationId: PropTypes.number,
  filter: PropTypes.string,
}

export default DashboardTodoFileListComponent
